export class Comment {

    public id: number;
    public edit_user_id?: number;
    public month?: string;
    public date?: string;
    public stop_id?: number;
    public user_id: number;
    public comment: string;
    public modified: string;
    public created: string;

    constructor(id: number, user_id: number, comment: string, modified: string, created: string,
                stop_id?: number, edit_user_id?: number, month?: string, date?: string) {
        this.id = id;
        this.user_id = id;
        this.comment = comment;
        this.modified = modified;
        this.created = created;
        this.stop_id = stop_id;
        this.edit_user_id = edit_user_id;
        this.month = month;
        this.date = date;
    }

}

export class CommentUpdate {

    public id: number;
    public comment: string;

    constructor(id: number, comment: string) {
        this.id = id;
        this.comment = comment;
    }

}

export class CommentCreate {

    public comment: string;
    public user_id: number;

    public edit_user_id: number;
    public month: string;
    public date: string;
    public route_id: number;

    constructor(comment: string, user_id: number, edit_user_id?: number, month?: string, date?: string, route_id?: number) {
        this.comment = comment;
        this.user_id = user_id;
        this.edit_user_id = edit_user_id;
        this.month = month;
        this.date = date;
        this.route_id = route_id;
    }

}
